<template>
  <div>
    <strong style="font-size: 150%">Avance Item</strong>
    <!--<div class="mt-2">
  <small>
    Disabled: {{ botonAvanceDeshabilitado }} |
    comentarios: "{{ comentariosAvance }}" |
    cuasiPedido: {{ cuasiPedido }} |
    estadoItem: {{ estadoItem }} |
    parado: {{ parado }} |
    rol: {{ currentUser && currentUser.roles[0] }}
  </small>
</div> -->

    <b-row class="mt-5 mb-3">
      <b-col>
        <label for="avancePropietario" class="form-label">Avance Propietario</label>
        <b-form-input
        style="font-size: 90%; background:rgb(228, 245, 229);"
          v-model="avancePropietario"
          id="avancePropietario"
        ></b-form-input>
      </b-col>
      <b-col cols="8">
        <label for="comentariosAvance" class="form-label">Comentarios</label>
        <b-form-input
        style="font-size: 90%;background:rgb(228, 245, 229);"
          v-model="comentariosAvance"
          id="comentariosAvance"
        ></b-form-input>
      </b-col>

      <b-col cols="1" style="padding: 29px 0px 0px 0px">
        <b-button
  :disabled="botonAvanceDeshabilitado"
  variant="success"
  class="actionButton"
  @click="addLineStopCriteria"
>
  +
</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-table
          style="font-size: 90%"
          class="shadow-sm vertical-center mt-4 text-center"
          responsive
          id="stopCriterias"
          :fields="$constants().avanceItemTableFields"
          :items="avance"
          bordered
          hover
          small
       
        >
        <template #cell(provisionado)="row" text-center>
    <span v-if="row.value === true" class="font-weight-bold text-danger">{{ row.value }}</span>
    <span v-else>{{ row.value }}</span>
  </template>


        
          <template #cell(action)="row" text-center>
            <b-button-group text-center size="sm">
              <b-button
               :disabled=" !['ROLE_SUPERADMIN', 'ROLE_SALES','ROLE_MANAGER','ROLE_TRAINING'].includes(currentUser.roles[0])"
                size="sm"
                class="actionButton"
                variant="outline-danger"
                @click="deleteLineStopCriteria(row)"
                ><i class="fas fa-trash-alt"></i
              ></b-button>
            </b-button-group>
          </template>
       <!--  <template
            #cell(provisionado)="row"
            v-if="this.$store.state.auth.user.roles[0] == 'ROLE_ADMIN'"
          >
            <td class="d-flex justify-content-center align-items-center">
              <input
                id="provisionado"
                type="checkbox"
                class="custom-checkbox"
                :checked="row.item.provisionado"
                @change="updateProvisionado(row.item)"
              />
            </td>
          </template>

           <template
            #cell(importeProvisionado)="row"
            text-center
            v-if="this.$store.state.auth.user.roles[0] == 'ROLE_ADMIN'"
          >
            <td class="d-flex justify-content-center align-items-center">
              <b-form-input
                @change="updateimporteProvisionado(row.item)"
                v-model="row.item.importeProvisionado"
                id="importeProvisionado"
              />
            </td>
          </template>-->
        </b-table>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <b-table
          v-show="shouldShowProvisionTable"
          style="font-size: 90%"
          class="shadow-sm vertical-center mt-4 text-center"
          responsive
          id="importeProvisionado"
          :fields="$constants().provisionItemTableFields"
          :items="filteredAvanceForProvisionTable"
          bordered
          hover
          small
        >
          <template
            #cell(facturadoProvision)="row"
            v-if="currentUser.roles[0] == 'ROLE_ADMIN'"
          >
            <td class="d-flex justify-content-center">
              <input
                type="checkbox"
                class="custom-checkbox"
                :checked="row.item.facturadoProvision"
                @change="updateProvisionadoFacturado(row.item)"
              />
            </td>
          </template>

          <template
            #cell(fechaFacturadoProvision)="row"
            text-center
            v-if="currentUser.roles[0] == 'ROLE_ADMIN'"
          >
            <b-input
              type="date"
              class="form-label"
              size="sm"
              v-model="row.item.fechaFacturadoProvision"
              id="numero"
              rows="1"
            ></b-input>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
//import AuthService from '../services/auth.service';
export default {
  props: {
    equipoTrabajo: {
      type: Array,
      required: true,
    },
    horasEstimadasTotal: {
      type: Number,
      required: true,
    },
    importeItem: {
      type: Number,
      required: true,
    },
    cuasiPedido: {
      type: Boolean,
      required: true,
    },
    estadoItem:{
      type: Boolean,
      required: true,
    },
    parado:{
      type: Boolean,
      required: true,
    },
    itemFinalizado: {
      type: Boolean,
      required: true,
    },
  },
  name: "AvanceItem",
  data() {
    return {
      avance: [],
      provisiones: [],
      avancePropietario: 0,
      avanceHoras: 0,
      comentariosAvance: "",
      fechaAvance: "",
      importeProvisionado: 0,
      provisionado: false,
      fechaProvisionado: "",
      facturadoProvision: false,
      fechaFacturadoProvision: "",
      //  horasRealesEquipoTrabajoTabla:'',
      importeEjecutado: "",
      horasRealesEquipoTrabajo: 0,
      importeProvisionadoTotal: 0,
      editingIndex: null,
      
    };
  },
  methods: {
    updateProvisionado(item) {
      item.provisionado = !item.provisionado;
      this.importeProvisionadoTotal = 0; // Reiniciar el total antes de recalcular
      this.avance.provisionado = item.provisionado;
      for (var j = 0; j < this.avance.length; j++) {
        if (this.avance[j].provisionado && this.avance[j].facturadoProvision == false) {
          this.importeProvisionadoTotal += parseFloat(this.avance[j].importeProvisionado);
        }
      }
      console.log(this.importeProvisionadoTotal);
      this.$emit("importeProvisionadoChange", this.importeProvisionadoTotal);
    },

    updateProvisionadoFacturado(item) {
      item.facturadoProvision = !item.facturadoProvision;
      this.importeProvisionadoTotal = 0; // Reiniciar el total antes de recalcular
      this.avance.facturadoProvision = item.facturadoProvision;
      for (var k = 0; k < this.avance.length; k++) {
        if (this.avance[k].provisionado && this.avance[k].facturadoProvision == false) {
          this.importeProvisionadoTotal += parseFloat(this.avance[k].importeProvisionado);
        }
        this.$emit("importeProvisionadoChange", this.importeProvisionadoTotal);
      }
    },
    updateImporteProvisionado(item) {
      console.log(item.importeProvisionado);
      this.importeProvisionado = item.importeProvisionado;
    },
    isCuasiPedido() {
      return (
        
        this.cuasiPedido === true
      );
    },

    addLineStopCriteria() {
      const today = new Date();
      this.fechaProvisionado = today;
      this.fechaAvance = today;

      this.importeEjecutado = parseFloat((this.avancePropietario * this.importeItem) / 100);

     // const newAvance = {
       // id: this.editingIndex !== null ? this.avance[this.editingIndex].id : Date.now(), // Use existing id if editing
       this.avance.push({
       fechaAvance: this.fechaAvance,
        horasRealesEquipoTrabajo: this.horasRealesEquipoTrabajo,
        avanceHoras: this.avanceHoras,
        avancePropietario: this.avancePropietario,
        comentariosAvance: this.comentariosAvance,
        importeEjecutado:  this.$parseDecimal(this.importeEjecutado),
        importeProvisionado:  this.$parseDecimal(this.importeProvisionado),
        provisionado: this.provisionado,
        facturadoProvision: this.facturadoProvision,
        fechaProvisionado: this.fechaProvisionado,
        fechaFacturadoProvision: this.fechaFacturadoProvision,
       
      });

     // if (this.editingIndex !== null) {
        // Update the existing item
       // this.$set(this.avance, this.editingIndex, newAvance);
        //this.editingIndex = null; // Reset editing index
      //} else {
        // Add new item
       // this.avance.push(newAvance);
      //}

      this.comentariosAvance = "";
      this.avancePropietario = 0;
      this.importeProvisionado = "";
      this.importeEjecutado = "";
      this.provisionado = false;
    
    },
    deleteLineStopCriteria(row) {
      this.avance.splice(row.index, 1);
    },
   
  },
  computed: {
    botonAvanceDeshabilitado() {
      
    return (
      this.comentariosAvance == '' ||
      (this.isCuasiPedido() && this.currentUser.roles[0] !== 'ROLE_SUPERADMIN') ||
      this.estadoItem === true ||
      this.parado === true ||
      this.itemFinalizado === true
    );
  },
    shouldShowProvisionTable() {
     // return this.avance.some((item) => item.provisionado);
    return false;
    },
    filteredAvanceForProvisionTable() {
      return this.avance.filter((item) => item.provisionado);
    },
    // Resto de las propiedades computadas...

    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      console.warn("Usuario no autenticado, redirigiendo a login...");
      this.$router.push("/login");
    }
  },
  components: {},
};
</script>
<style>
.custom-checkbox {
  width: 20px;
  height: 20px;
  display: flex; /* Activa el flex container */
  justify-content: center; /* Centra horizontalmente el contenido */
  align-items: center; /* Centra verticalmente el contenido */
  border: 1px solid #ccc; /* Agrega un borde para resaltar el checkbox */
}
</style>
